import BaseExcelService from './BaseExcelService';

class DistributorExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/distributor';
  }
}

export default new DistributorExcelService();
